import { request } from "./api";
import type { CalendarOverview } from "./types";

type ApiResponse<T> = { data: T };

export async function getCalendar(start: string, end: string, teamId?: string) {
  const query = new URLSearchParams({ start, end });
  if (teamId) query.set("teamId", teamId);
  const response = await request<ApiResponse<CalendarOverview>>(
    `/v1/admin/calendar?${query.toString()}`,
  );
  return response.data;
}
